import { computed, getCurrentInstance, type ComputedRef } from 'vue'
import type { Pinia } from 'pinia'
import { useContextStore } from 'src/store'

/**
 * Мобильная ли сейчас версия сайта.
 *
 * Использование в любом Vue-компоненте (SSR и www):
 *   const isMobile = useIsMobile()
 *   // в template: v-if="isMobile"
 *   // в script:   if (isMobile.value) { ... }
 *
 * Откуда берёт значение:
 *   1. Pinia context.flavour — на SSR-страницах
 *   2. window.MOBILE_VERSION — в legacy www, если Pinia нет
 *
 * Не используем getActivePinia(): в setup без Pinia он делает inject
 * и сыпет Vue warn "injection Symbol(pinia) not found" (DoctorCases и т.п.).
 */
export default function useIsMobile(): ComputedRef<boolean> {
  const instance = getCurrentInstance()
  const pinia = (instance?.proxy as { $pinia?: Pinia } | undefined)?.$pinia

  return computed(() => {
    if (pinia) {
      const { context } = useContextStore(pinia)

      if (context.flavour) {
        return context.flavour === 'mobile'
      }
    }

    return Boolean(process.env.IS_CLIENT && window.MOBILE_VERSION)
  })
}
